/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Liveroomherenow3Inputs */

const en_liveroomherenow3 = /** @type {(inputs: Liveroomherenow3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} in the Live Room right now`)
};

const de_liveroomherenow3 = /** @type {(inputs: Liveroomherenow3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gerade ${i?.count} im Live Room`)
};

/**
* | output |
* | --- |
* | "{count} in the Live Room right now" |
*
* @param {Liveroomherenow3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const liveroomherenow3 = /** @type {((inputs: Liveroomherenow3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liveroomherenow3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liveroomherenow3(inputs)
	return de_liveroomherenow3(inputs)
});
export { liveroomherenow3 as "liveRoomHereNow" }